<template>
<div class="chapter">
<div class="inner_page">
<div class="ipadfp"><img alt="Cover: Cold Cases: A True Crime Collection, by Cheyna Roth" aria-describedby="cover-alt" class="imagefp" epub:type="cover" role="doc-cover" src="e9781646041145/images/9781646041145.jpg"/></div>
<aside hidden="hidden" id="cover-alt">
<p>Cold Cases: A True Crime Collection</p>
<p>Unidentified Serial Killers, Unsolved Kidnappings, and Mysterious Murders</p>
<p>Cheyna Roth</p>
</aside>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// cover.vue?86a92176